import { render, staticRenderFns } from "./staffpk.vue?vue&type=template&id=599ac066&scoped=true&"
import script from "./staffpk.vue?vue&type=script&lang=js&"
export * from "./staffpk.vue?vue&type=script&lang=js&"
import style0 from "./staffpk.vue?vue&type=style&index=0&id=599ac066&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599ac066",
  null
  
)

export default component.exports